import { PlanV2 } from "@zapier/checkout/esm/types";

/**
 *  A user on the same plan and interval shouldn't be allowed to proceed since it's essentially a no-op
 */
export const isSamePlanAndInterval = (currentPlan: any, toPlan?: PlanV2) => {
  return (
    currentPlan?.id === toPlan?.id && currentPlan?.interval === toPlan?.interval
  );
};
